// extracted by mini-css-extract-plugin
export default {"container":"UserRank_container__ijEpz"};